// =============================================================
// OOS Rescue — vanilla JS
// 1) Notify-me form: submits to Klaviyo's Client Back-in-Stock API
// 2) Size pills: bulletproof event delegation
// 3) Lazy-loads "We have these alternatives" recommendations
// =============================================================

// --- 1 & 2: Notify-me form + size pill delegation ---
(function () {
  function init() {
    document.querySelectorAll('[data-notify-me]').forEach(setupForm);
  }

  function setupForm(root) {
    var form      = root.querySelector('[data-notify-form]');
    var emailEl   = root.querySelector('[data-notify-email]');
    var btn       = root.querySelector('[data-notify-submit]');
    var label     = root.querySelector('[data-notify-label]');
    var errorEl   = root.querySelector('[data-notify-error]');
    var successEl = root.querySelector('[data-notify-success]');
    var sizesWrap = root.querySelector('.notify-me__sizes');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl.value || '').trim();
      if (!email) return;

      btn.disabled = true;
      label.textContent = 'Sending…';
      errorEl.hidden = true;

      var klaviyoId = (root.dataset.klaviyoId || '').trim();
      var variantId = root.dataset.activeVariantId;

      var payload = {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: { email: email }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                // If your Klaviyo Shopify catalog feed is not named "default",
                // change "$default" below to match.
                id: '$shopify:::$default:::' + variantId
              }
            }
          }
        }
      };

      fetch(
        'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' +
          encodeURIComponent(klaviyoId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'accept': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify(payload)
        }
      )
        .then(function (res) {
          if (!res.ok && res.status !== 202) {
            return res.text().then(function (t) {
              throw new Error('Klaviyo HTTP ' + res.status + ': ' + t);
            });
          }
          form.hidden = true;
          if (sizesWrap) sizesWrap.hidden = true;
          successEl.hidden = false;
        })
        .catch(function (err) {
          console.error('Notify-me submit failed', err);
          errorEl.textContent = 'Something went wrong. Try again in a moment.';
          errorEl.hidden = false;
          btn.disabled = false;
          label.textContent = 'Notify me';
        });
    });
  }

  // Pill click delegation — survives re-renders
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-variant-pill]');
    if (!pill) return;
    var root = pill.closest('[data-notify-me]');
    if (!root) return;

    root.querySelectorAll('[data-variant-pill]').forEach(function (p) {
      p.classList.remove('is-active');
      p.setAttribute('aria-pressed', 'false');
    });
    pill.classList.add('is-active');
    pill.setAttribute('aria-pressed', 'true');
    root.dataset.activeVariantId = pill.dataset.variantId;
  });

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Read More link — smooth scroll to the main product section
document.addEventListener('click', function (e) {
  var link = e.target.closest('[data-oos-readmore]');
  if (!link) return;
  e.preventDefault();

  // Try to find Horizon's main product section, in order of likelihood
  var target =
    document.querySelector('product-information') ||
    document.querySelector('[id^="shopify-section"][id*="main"]') ||
    document.querySelector('shopify-section[type="product-information"]');

  // Fallback: next sibling of the OOS rescue section's wrapper
  if (!target) {
    var rescue = document.querySelector('[data-oos-rescue]');
    if (rescue) {
      var wrapper = rescue.closest('shopify-section, [id^="shopify-section"]') || rescue.parentElement;
      if (wrapper && wrapper.nextElementSibling) {
        target = wrapper.nextElementSibling;
      }
    }
  }

  if (target && target.scrollIntoView) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
});
})();


// --- 3: Async product-recommendations loader